import { Typography, Row } from "antd";

import "./app-title.css";

function AppTitle({ text, level = 2, className = "" }) {
  const titleClassName = ["title__h2", className].filter(Boolean).join(" ");

  return (
    <Row className="content">
      <Typography.Title
        key={text}
        className={titleClassName}
        editable
        level={level}
        style={{ margin: 0 }}
      >
        {text}
      </Typography.Title>
    </Row>
  );
}

export default AppTitle;
